const StepComponent: React.FC<{textValue: string }> = (
    {textValue}
) => {

    return(
        <div>{textValue}</div>
    )
};

export default StepComponent;
